import api from "./api";

/**
 * Gera a URL da thumbnail a partir da playbackUrl (HLS).
 * O MediaConvert gera source_thumb.0000001.jpg no mesmo diretório do master.m3u8.
 */
export function getVideoThumbnailUrl(
  playbackUrl: string | null | undefined,
): string | null {
  if (!playbackUrl?.includes(".m3u8")) return null;
  return playbackUrl.replace(/\/master\.m3u8(?:\?.*)?$/i, "/source_thumb.0000001.jpg");
}

export type InitVideoUploadResponse = {
  assetId: string;
  bucket: string;
  key: string;
  uploadId: string;
  partSize: number;
  playbackUrl: string;
  thumbnailUrl?: string;
};

export async function initVideoUpload(params: {
  fileName: string;
  contentType?: string;
}): Promise<InitVideoUploadResponse> {
  const { data } = await api.post<InitVideoUploadResponse>("/videos/uploads/", {
    file_name: params.fileName,
    content_type: params.contentType || "video/mp4",
  });
  return data;
}

export async function presignVideoPart(params: {
  assetId: string;
  partNumber: number;
}): Promise<{ url: string }> {
  const { data } = await api.post<{ url: string }>(
    `/videos/${params.assetId}/uploads/parts/`,
    { partNumber: params.partNumber },
  );
  return data;
}

export async function completeVideoUpload(params: {
  assetId: string;
  parts: Array<{ ETag: string; PartNumber: number }>;
}): Promise<{ assetId: string; status: string; playbackUrl: string }> {
  const { data } = await api.post<{
    assetId: string;
    status: string;
    playbackUrl: string;
  }>(`/videos/${params.assetId}/uploads/complete/`, { parts: params.parts });
  return data;
}

export async function abortVideoUpload(params: { assetId: string }) {
  const { data } = await api.post(`/videos/${params.assetId}/uploads/abort/`, {});
  return data;
}

export async function getVideoAsset(assetId: string): Promise<{
  assetId: string;
  status: string;
  playbackUrl: string;
  thumbnailUrl?: string;
}> {
  const { data } = await api.get(`/videos/${assetId}/`);
  return data;
}

